<div class="content-block">
  <div class="row">
    <div class="col-md-6">
      <h2 class="content-block">Cambio password</h2>
    </div>
    <div class="col-md-6">
      <span class="float-end">




      </span>
    </div>
  </div>
</div>

<div class="content-block">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="nav-tabs-custom">
          <ul class="nav nav-pills">
            <li class="nav-item"><a class="nav-link active" href="#nuovo" data-bs-toggle="tab">Cambio password</a></li>
          </ul>
        </div>
        <div class="card-body">
          <div class="tab-content">
            <div class="active tab-pane" id="nuovo">
              <div style="padding:10px; width:400px">
                @if (username && parametriPasswords) {
                  <app-ildato-aggiorna-password
                    [username]="username"
                    [parametriPasswords]="parametriPasswords"
                    (ilDatoAggiornaPasswordEventEmitter)="onIlDatoAggiornaPasswordEvent($event)">
                  </app-ildato-aggiorna-password>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadPanelVisible"
  [showIndicator]="true" [showPane]="true" [shading]="true" [hideOnOutsideClick]="false">
</dx-load-panel>